// Throttle function to limit the frequency of checks
export default function throttle(fn, limit) {
	let lastCall = 0;
	return function (...args) {
		const now = Date.now();
		if (now - lastCall >= limit) {
			lastCall = now;
			fn(...args);
		}
	};
}

export function onResize(callback) {
	let resizeTimeout;

	// Internal resize handler
	function handleResize(e) {
		// Cancel the previous requestAnimationFrame if it exists
		if (resizeTimeout) {
			cancelAnimationFrame(resizeTimeout);
		}

		// Request a new animation frame
		resizeTimeout = requestAnimationFrame(() => {
			// Call the provided callback function
			callback(e);
		});
	}

	// Add the resize event listener with passive option for better performance
	window.addEventListener('resize', handleResize, { passive: true });

	// Return a function to remove the listener if needed
	return () => {
		window.removeEventListener('resize', handleResize, { passive: true });
		if (resizeTimeout) {
			cancelAnimationFrame(resizeTimeout);
		}
	};
}

export function onResizeWidth(callback) {
	let resizeTimeout;
	let lastWidth = window.innerWidth;

	// Internal resize handler
	function handleResize(e) {
		const currentWidth = window.innerWidth;
		if (currentWidth !== lastWidth) {
			lastWidth = currentWidth;

			// Cancel the previous requestAnimationFrame if it exists
			if (resizeTimeout) {
				cancelAnimationFrame(resizeTimeout);
			}

			// Request a new animation frame
			resizeTimeout = requestAnimationFrame(() => {
				// Call the provided callback function
				callback(e);
			});
		}
	}

	// Add the resize event listener with passive option for better performance
	window.addEventListener('resize', handleResize, { passive: true });

	// Return a function to remove the listener if needed
	return () => {
		window.removeEventListener('resize', handleResize, { passive: true });
		if (resizeTimeout) {
			cancelAnimationFrame(resizeTimeout);
		}
	};
}

export function onMouseMove(callback) {
	let mouseMoveTimeout;

	// Internal mousemove handler
	function handleMouseMove(e) {
		// Cancel the previous requestAnimationFrame if it exists
		if (mouseMoveTimeout) {
			cancelAnimationFrame(mouseMoveTimeout);
		}

		// Request a new animation frame
		mouseMoveTimeout = requestAnimationFrame(() => {
			// Call the provided callback function
			callback(e);
		});
	}

	// Add the mousemove event listener with passive option for better performance
	document.addEventListener('mousemove', handleMouseMove, { passive: true });

	// Return a function to remove the listener if needed
	return () => {
		document.removeEventListener('mousemove', handleMouseMove, { passive: true });
		if (mouseMoveTimeout) {
			cancelAnimationFrame(mouseMoveTimeout);
		}
	};
}
